import http from "./http-common";
import authHeader from "./auth-header";
import process from "shelljs";

const API_URL = process.env.BFF_URL;

class AccountService {

  findAll(customerId, mid, page, size) {
    const context = JSON.parse(localStorage.getItem('selectedContext'));
    if (!context || !context.contextId) {
      throw new Error('Customer context is required');
    }
    const customerCtxId = context.contextId;
    return http.get(API_URL + `/v1/customers/${customerCtxId}/accounts?page=${page}&size=${size}`, {headers: authHeader()})
  }

  findAccountTransactions(mid, id, page, size) {
    const context = JSON.parse(localStorage.getItem('selectedContext'));
    if (!context || !context.contextId) {
      throw new Error('Customer context is required');
    }
    const customerId = context.contextId;
    return http.get(API_URL + `/v1/customers/${customerId}/accounts/${id}/transactions?page=${page}&size=${size}`, {headers: authHeader()})
  }

  findAccountTransactions(mid, accountId, type, page, size) {
    const context = JSON.parse(localStorage.getItem('selectedContext'));
    if (!context || !context.contextId) {
      throw new Error('Customer context is required');
    }
    const customerId = context.contextId;
    return http.get(API_URL + `/v1/customers/${customerId}/transactions`, {
      headers: authHeader(),
      params: {
        accountId: accountId,
        type: type,
        page: page,
        size: size
      }
    })
  }

  create(mid, account) {
    const context = JSON.parse(localStorage.getItem('selectedContext'));
    if (!context || !context.contextId) {
      throw new Error('Customer context is required');
    }
    const customerId = context.contextId;
    return http.post(API_URL + `/v1/customers/${customerId}/accounts`, account, {headers: authHeader()});
  }

  update(mid, id, user) {
    const context = JSON.parse(localStorage.getItem('selectedContext'));
    if (!context || !context.contextId) {
      throw new Error('Customer context is required');
    }
    const customerId = context.contextId;
    return http.put(API_URL + `/v1/customers/${customerId}/accounts/${id}`, user, {headers: authHeader()});
  }

  topUp(mid, id, data) {
    const context = JSON.parse(localStorage.getItem('selectedContext'));
    if (!context || !context.contextId) {
      throw new Error('Customer context is required');
    }
    const customerId = context.contextId;
    return http.post(API_URL + `/v1/customers/${customerId}/accounts/${id}/top-up`, data, {headers: authHeader()});
  }

  findById(mid, id) {
    const context = JSON.parse(localStorage.getItem('selectedContext'));
    if (!context || !context.contextId) {
      throw new Error('Customer context is required');
    }
    const customerId = context.contextId;
    return http.get(API_URL + `/v1/customers/${customerId}/accounts/${id}`, {headers: authHeader()});
  }

  statement(mid, id, params) {
    const context = JSON.parse(localStorage.getItem('selectedContext'));
    if (!context || !context.contextId) {
      throw new Error('Customer context is required');
    }
    const customerId = context.contextId;
    return http.get(API_URL + `/v1/customers/${customerId}/accounts/${id}/statement`, {params: params, headers: authHeader()})
  }

  delete(mid, id) {
    const context = JSON.parse(localStorage.getItem('selectedContext'));
    if (!context || !context.contextId) {
      throw new Error('Customer context is required');
    }
    const customerId = context.contextId;
    return http.delete(API_URL + `/v1/customers/${customerId}/accounts/${id}`, {headers: authHeader()});
  }

  find(mid, params) {
    const context = JSON.parse(localStorage.getItem('selectedContext'));
    if (!context || !context.contextId) {
      throw new Error('Customer context is required');
    }
    const customerId = context.contextId;
    return http.get(API_URL + `/v1/customers/${customerId}/accounts`, {params: params, headers: authHeader()})
  }

  handleResponse(response) {
    return response
  }
}

export default new AccountService();



// WEBPACK FOOTER //
// ./src/service/account.service.js